export default(cartItems, italicDiscount, cartPrices) => ({
    current: window.location.pathname.split('/')[1],
    showTopArrow: false,
    dim: false,
    typefaceDD: false,
    commissionsDD: false,
    mobilemenu: false,
    showBuy: true,
    closeDDs() {
        if(this.mobilemenu == true) {
            this.dim = false;
            this.typefaceDD = false;
            this.commissionsDD = false;
            this.mobilemenu = false;
        } else {
            this.dim = false;
            this.typefaceDD = false;
            this.commissionsDD = false;
        }
    },
    handleBuy($el) {
        if(this.mobile) {
            console.log('open buy link');
            // console.log($el.href);
            window.open($el.href,'_blank');
        } else {
            console.log('jumpToBuying');
            let buying = window.pageYOffset + document.getElementById('buying').getBoundingClientRect().top - 100;
            window.scrollTo(0, buying);
        }
    },
    toggleMobileMenu() {
        console.log('toggleMobileMenu');
        this.mobilemenu = ! this.mobilemenu; 
        this.dim = ! this.dim;
    },
    handleDD(el) {
        
        // if dd clicked inside mobile menu
        if(this.mobilemenu == true) {
            console.log('mobilemenu dd fired');
        
            if(el.innerText == 'Typefaces') {
                if(this.typefaceDD == true) {
                this.typefaceDD = false;
                } else {
                this.commissionsDD = false;
                this.typefaceDD = true;
                }
            } 
        
            if(el.innerText == 'Commissions') {
                if(this.commissionsDD == true) {
                this.commissionsDD = false;
                } else {
                this.typefaceDD = false;
                this.commissionsDD = true;
                }
            } 
    
        } else {
            console.log('dd fired');
            // close menu
            if(this.dim == true) {    
                console.log('close menu');  
                if(this.typefaceDD == true) {
                if(el.innerText == 'Typefaces') {
                    this.dim = false;
                    this.typefaceDD = false;
                } else {
                    this.typefaceDD = false;
                    this.commissionsDD = true;
                }
                } else if(this.commissionsDD == true) {
                if(el.innerText == 'Commissions') {
                    this.dim = false;
                    this.commissionsDD = false;
                } else {
                    this.typefaceDD = true;
                    this.commissionsDD = false;
                }
                } else {
                
                this.dim = false;
                this.typefaceDD = false;
                this.commissionsDD = false;
        
                }
            
            // open menu
            } else {
                console.log('open menu');
                this.dim = true;
                // if typefaces clicked
                if(el.innerText == 'Typefaces') {
        
                this.typefaceDD = true;
                this.commissionsDD = false;
                
                // if commissions clicked
                } else {
                this.typefaceDD = false;
                this.commissionsDD = true;
                }
            }
        }
    },

    handleScroll() {
        if(document.querySelector('.totop') && window.pageYOffset  > 300) {
        this.showTopArrow = true;
        } else {
        this.showTopArrow = false;
        }
    },
    
    mobile: window.matchMedia('only screen and (max-width: 760px)').matches,

    // Data coming in from Kirby to be moved into $store
    cartItems: cartItems,
    cartConstants: italicDiscount,
    cartPrices: cartPrices
});